import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Grid,
  MenuItem,
  CircularProgress,
  Select,
  TextField,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
   IconButton,
   useMediaQuery, useTheme
} from "@mui/material";
import { useParams , useNavigate} from "react-router-dom";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";





const PromoteProductPage = () => {
  const { productId } = useParams();
  console.log("Product ID from URL:", productId);
  const navigate = useNavigate();

  const [product, setProduct] = useState({
    title: "",
    categoryName: "",
    description: "",
    price: 0,
    location: "",
    promotionStatus: "",
    imagePaths: [],
    videoPath: "",
    postByUserid: 0,
  });
 
  const [category, setCategory] = useState('');
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [price, setPrice] = useState('');
  const [location, setLocation] = useState('');
  const [availability, setAvailability] = useState('');
  const [duration, setDuration] = useState('');
const [promotionDuration, setPromotionDuration] = useState('');
  const [categoryId, setCategoryId] = useState(null); // Add a state for categoryId
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const [selectedProduct, setSelectedProduct] = useState(null);

  const [loading, setLoading] = useState(false); 
  const [successModalOpen, setSuccessModalOpen] = useState(false); 
  const [errorModalOpen, setErrorModalOpen] = useState(false); 



  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const token = localStorage.getItem("token"); 
        if (!token) {
          console.error("No token found. Please log in.");
          return;
        }
  
        const response = await fetch(
          `https://daradservice.azurewebsites.net/api/P2PProducts/get-product?productId=${productId}`,
          {
            headers: {
              "Accept": "application/json",
              "Authorization": `Bearer ${token}`,
            },
          }
        );
  
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
  
        const data = await response.json();
  
        if (data.status) {
          setProduct(data.data);
          setCategory(data.data.categoryName);
          setCategoryId(data.data.categoryId);
          setTitle(data.data.title);
          setSelectedProduct(data.data); 
          setDescription(data.data.description);
          setPrice(data.data.price);
          setLocation(data.data.location);
          setAvailability(data.data.availabiltyDuration || '');
          setPromotionDuration(data.data.promotionDuration || '');
          setSelectedProduct(data.data);  
        } else {
          console.error("Product not found");
        }
      } catch (error) {
        console.error("Error fetching product:", error);
      }
    };
  
    fetchProduct();
  }, [productId]);
  

// Log state changes
useEffect(() => {
    console.log("Updated Product State:", product);
}, [product]);

  
  // Calculate promotion cost
  const promotionCost = promotionDuration ? promotionDuration * 500 : 0;

  const handlePromoteProduct = async () => {
    const token = localStorage.getItem("token");
    const storedEmail = sessionStorage.getItem("userEmail");
  
    if (!token || !storedEmail) {
      console.error("Token or User email is missing. Please log in.");
      return;
    }
  
    const apiUrl = "https://daradservice.azurewebsites.net/api/P2PProducts/promote-product";
  
    const promotionData = {
      setPromo: true,
      promotionCost: promotionDuration * 500, // Ensure this is correctly calculated
      promotionDuration: promotionDuration,
      email: storedEmail, // Add email here
      productId: parseInt(productId), // Convert productId to a number if needed
    };
  
    setLoading(true);
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Accept": "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(promotionData),
      });
  
      if (response.ok) {
        setSuccessModalOpen(true);
      } else {
        throw new Error("Failed to promote product");
      }
    } catch (error) {
      console.error("Error promoting product:", error);
      setErrorModalOpen(true);
    } finally {
      setLoading(false);
    }
  };
  




const handleEditProduct = () => {
  if (!product) {
    console.error("Product is null or undefined!");
    return;
  }

  
  if (!productId) {  // Assuming the product object contains 'id' for productId
    console.error("Missing productId in product:", product);
    return;
  }

 
  navigate(`/product/edit/${productId}`);
};






  return (
    
    <Box sx={{ mt: 3 }}>
          <Box sx={{ width: "100%", p: isDesktop ? 4 : 2, position: "relative" }}>
    
          <IconButton 
      onClick={() => navigate("/product/ptwop")} 
      sx={{ 
        position: "absolute",
        top: 20,
        left: 20,
        color: "white", 
        background: "#5604F6 !important",  // Ensure the background is applied
        fontSize: "48px",
        borderRadius: "50px",
        zIndex: 1000, // Ensure it's above other elements
        "&:hover": { background: "#4503D6 !important" } 
      }}
    >
      <ArrowBackIcon />
    </IconButton>
    </Box>
    <Box
      sx={{
        maxWidth: "800px",
        margin: "auto",
        padding: "30px",
        borderRadius: "12px",
        mb: "40px",
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
        backgroundColor: "white",
      }}
    >
      {/* Title */}
      <Typography
        variant="h5"
        align="center"
        fontWeight="800"
        sx={{ color: "#2400FF", mb: 1, fontSize: isDesktop ? "48px" : "36px", }}
        
      >
        Product Details
      </Typography>
      <Typography align="center" sx={{ mb: 3, color: "#777" }}>
      Check all the details before submitting. You can go back to make changes.
      </Typography>

      {/* Main Product Image */}
     
      <Box sx={{ display: "flex", flexDirection: "row", flexWrap: "wrap", gap: 2 }}>
  {product.imagePaths && product.imagePaths.length > 0 ? (
    product.imagePaths.map((image, index) => (
      <Box
        key={index}
        component="img"
        src={image}
        alt={`Product Image ${index + 1}`}
        sx={{
          width: "120px",
          height: "120px",
          objectFit: "cover",
          borderRadius: "8px",
          border: "2px solid #ccc",
        }}
      />
    ))
  ) : (
    <Typography>No images available</Typography>
  )}
</Box>


<Box sx={{ display: "flex", flexDirection: "row", alignItems: "flex-start" }}>
  {/* Image Thumbnails */}
  <Grid container spacing={1} sx={{ my: 2, justifyContent: "center", flexDirection: "column" }}>
  
      <Grid >
        <Box
          component="img"
          // src={img}
          // alt={`Thumbnail ${index + 1}`}
          sx={{
            width: "65px",
            height: "65px",
            objectFit: "cover",
            borderRadius: "6px",
            border: "2px solid #ccc",
          }}
        />
      </Grid>
 
  </Grid>

  {/* Form */}
  <Grid container direction="column" spacing={2} sx={{ ml: 4 }}>
    <Grid item xs={12}>
      <Typography fontWeight="500" sx={{ mb: 1 }}>
        Category
      </Typography>
      <TextField
        fullWidth
        value={product.categoryName}
        onChange={(e) => setTitle(e.target.value)}
        sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: "12px",
            backgroundColor: "#fff",
           
            fontSize: isDesktop ? 18 : 16
          },
          "& .MuiInputBase-input::placeholder": {
            color: "#A0A0A0",
          
            fontSize: isDesktop ? 14 : 18
          },
        }}
      />
    </Grid>

    <Grid item xs={12}>
      <Typography fontWeight="bold" fontSize={24} sx={{ mb: 1 }}>
        Product Title
      </Typography>
      <TextField
        fullWidth
        value={title}
        onChange={(e) => setTitle(e.target.value)}
        sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: "12px",
            backgroundColor: "#fff",
           
            fontSize: isDesktop ? 18 : 16
          },
          "& .MuiInputBase-input::placeholder": {
            color: "#A0A0A0",
          
            fontSize: isDesktop ? 14 : 18
          },
        }}
      />
    </Grid>

    <Grid item xs={12}>
      <Typography fontWeight="500" sx={{ mb: 1 }}>
        Description
      </Typography>
      <TextField
        fullWidth
        multiline
        rows={3}
        value={description}
        onChange={(e) => setDescription(e.target.value)}
        sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: "12px",
            backgroundColor: "#fff",
           
            fontSize: isDesktop ? 18 : 16
          },
          "& .MuiInputBase-input::placeholder": {
            color: "#A0A0A0",
          
            fontSize: isDesktop ? 14 : 18
          },
        }}
      />
    </Grid>
  </Grid>
</Box>




      {/* Form Fields */}
      <Grid container spacing={2}>
       

       

       

        <Grid item xs={12} sm={6}>
          <Typography fontWeight="500" sx={{ mb: 1 }}>
            Price
          </Typography>
          <TextField
            fullWidth
            value={price}
            onChange={(e) => setPrice(e.target.value)}
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: "12px",
                backgroundColor: "#fff",
               
                fontSize: isDesktop ? 18 : 16
              },
              "& .MuiInputBase-input::placeholder": {
                color: "#A0A0A0",
              
                fontSize: isDesktop ? 14 : 18
              },
            }}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <Typography fontWeight="500" sx={{ mb: 1 }}>
            Location
          </Typography>
          <TextField
            fullWidth
            value={location}
            onChange={(e) => setLocation(e.target.value)}
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: "12px",
                backgroundColor: "#fff",
               
                fontSize: isDesktop ? 18 : 16
              },
              "& .MuiInputBase-input::placeholder": {
                color: "#A0A0A0",
              
                fontSize: isDesktop ? 14 : 18
              },
            }}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <Typography fontWeight="500" sx={{ mb: 1 }}>
            Availability Duration
          </Typography>
          <Select
            fullWidth
            value={availability}
            onChange={(e) => setAvailability(e.target.value)}
            sx={{
              borderRadius: "8px",
              height: "45px",
              backgroundColor: "#F9F9F9",
            }}
          >
           {[...Array(30).keys()].map((num) => (
              <MenuItem key={num + 1} value={num + 1}>{num + 1} Days</MenuItem>
            ))}
          </Select>
        </Grid>

        <Grid item xs={12} sm={6}>
          <Typography fontWeight="500" sx={{ mb: 1 }}>
            Promotion Duration
          </Typography>
          <Select
            fullWidth
            value={promotionDuration}
            onChange={(e) => setPromotionDuration(e.target.value)}
            sx={{
              borderRadius: "8px",
              height: "45px",
              backgroundColor: "#F9F9F9",
            }}
          >
            {[...Array(30).keys()].map((num) => (
              <MenuItem key={num + 1} value={num + 1}>
                {num + 1} Days
              </MenuItem>
            ))}
          </Select>
        </Grid>

        {/* Display Promotion Cost */}
        {promotionDuration && (
          <Grid item xs={12}>
            <Typography variant="body1" sx={{ fontWeight: "500", color: "#FF0000", mt: 2 }}>
              Promotion Cost: ₦{promotionCost}
            </Typography>
          </Grid>
        )}
      </Grid>
      
     
      {/* Buttons */}
         {/* Buttons */}
         <Box sx={{ display: "flex", justifyContent: "center", gap:8, mt: 4 }}>
      

      <Button
        
        color="secondary"
        sx={{
          width: isDesktop ? "40%" : "100%",
          padding: "10px 20px", 
          borderRadius: "25px", 
          backgroundColor: "#EEE6FE  !important",
          color: "#5604F6!important",
          textTransform: "none",
        
          fontSize: isDesktop ? "16px" : "18px",
          "&:hover": { backgroundColor: "#B0B0B0" },
                  }}
        onClick={handleEditProduct} 
      >
        EDIT PRODUCT
      </Button>
      
      <Button
  variant="contained"
  fullWidth
  sx={{
    mt:"10px",
    width: isDesktop ? "40%" : "100%", 
    height: isDesktop ? "40%" : "100%",
    padding: "10px 20px", 
    borderRadius: "25px",
    backgroundColor: "#5604F6 !important",
    color: "#EEE6FE !important",

    fontSize: isDesktop ? "16px" : "18px",
 
  }}
  onClick={handlePromoteProduct}
  disabled={loading} 
>
  {loading ? <CircularProgress size={24} sx={{ color: "white" }} /> : "Promote"}
</Button>

                 </Box>

      {/* Success Modal */}
      <Dialog
        open={successModalOpen}
        onClose={() => setSuccessModalOpen(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>Success!</DialogTitle>
        <DialogContent>
          <Typography variant="body1" color="textSecondary" fontSize="20px">
          Product promoted successfully! Your promotion will last for {promotionDuration} days
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setSuccessModalOpen(false)} color="#5604F6">
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* Error Modal */}
      <Dialog
        open={errorModalOpen}
        onClose={() => setErrorModalOpen(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>Error!</DialogTitle>
        <DialogContent>
          <Typography variant="body1" color="textSecondary">
            Something went wrong. Please try again.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setErrorModalOpen(false)} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
    </Box>
  );
};



export default PromoteProductPage;
